/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Ai_Stage_Discover_DescInputs */

const en_directory_detail_signals_ai_stage_discover_desc = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_Discover_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`llms.txt and sitemap declarations that let agents find the product's machine-readable surface.`)
};

const zh_directory_detail_signals_ai_stage_discover_desc = /** @type {(inputs: Directory_Detail_Signals_Ai_Stage_Discover_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`llms.txt 与 sitemap 声明，让 Agent 找到产品的机器可读入口。`)
};

/**
* | output |
* | --- |
* | "llms.txt and sitemap declarations that let agents find the product's machine-readable surface." |
*
* @param {Directory_Detail_Signals_Ai_Stage_Discover_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_ai_stage_discover_desc = /** @type {((inputs?: Directory_Detail_Signals_Ai_Stage_Discover_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Ai_Stage_Discover_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_ai_stage_discover_desc(inputs)
	return zh_directory_detail_signals_ai_stage_discover_desc(inputs)
});
export { directory_detail_signals_ai_stage_discover_desc as "directory.detail.signals.ai_stage.discover_desc" }